import type { CSSProperties, ElementType, ReactNode } from 'react'
import { cn } from '@/lib/cn'
import styles from './Text.module.css'

export type TextVariant =
  | 'display'
  | 'title'
  | 'heading'
  | 'subtitle'
  | 'body'
  | 'caption'
  | 'eyebrow'
export type TextWeight = 'regular' | 'medium' | 'semibold' | 'bold'
export type TextTone =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'onDark'
  | 'onDarkMuted'
  | 'accent'
  | 'positive'
  | 'negative'
  | 'inherit'

export interface TextProps {
  readonly as?: ElementType | undefined
  readonly variant?: TextVariant | undefined
  readonly weight?: TextWeight | undefined
  readonly tone?: TextTone | undefined
  /** Tabular figures — use for any column of numbers. */
  readonly numeric?: boolean | undefined
  readonly truncate?: boolean | undefined
  readonly className?: string | undefined
  readonly style?: CSSProperties | undefined
  readonly role?: string | undefined
  readonly id?: string | undefined
  readonly children: ReactNode
}

export function Text({
  as: Tag = 'p',
  variant = 'body',
  weight = 'regular',
  tone = 'primary',
  numeric = false,
  truncate = false,
  className,
  style,
  role,
  id,
  children,
}: TextProps) {
  return (
    <Tag
      className={cn(
        styles.text,
        styles[variant],
        styles[weight],
        styles[tone],
        numeric && styles.numeric,
        truncate && styles.truncate,
        className,
      )}
      style={style}
      role={role}
      id={id}
    >
      {children}
    </Tag>
  )
}
